import chineseMessages from '@haxqer/ra-language-chinese';
import { merge } from 'lodash';
import { TranslationMessages } from 'react-admin';
import en from './en';
import packageLanguage from './packages/zh.json';

const lang: TranslationMessages = merge({}, en, chineseMessages, packageLanguage);

export default lang;
